import styled from 'styled-components';
import {device} from './device';

export const HeroPlusCont = styled.div`
  display: flex;
  padding: 0 0 80px 0;
  max-width: 970px;
  margin: 0 auto;
  margin-top: 62px;
  justify-content: space-between;
  h3 {
    font-size: 32px;
    line-height: 42px;
    color: #4e3f6e;
    font-weight: 400;
    span {
      font-weight: 900;
    }
    @media ${device.mobileS} {
      font-size: 24px;
      line-height: 32px;
      text-align: center;
    }
  }
  @media ${device.mobileS} {
    padding: 30px;
    flex-direction: column-reverse;
  }
`;
export const HeroPlusContLft = styled.div`
  width: 400px;
  flex-shrink: 0;
  @media ${device.mobileS} {
    width: 100%;
    h3 {
      display: none;
    }
  }
  h5 {
    font-size: 18px;
    line-height: 24px;
    margin-top: 6px;
    font-weight: 400;
    span {
      font-weight: 900;
    }
    @media ${device.mobileS} {
      display: none;
    }
  }
  .highlightText {
    background: #fbdf6a;
  }
  .inline-text span {
    append-right: 10px;
    display: inline;
  }
  p {
    font-size: 16px;
    line-height: 24px;
    span {
      font-weight: 900;
    }
    @media ${device.mobileS} {
      font-size: 14px;
      line-height: 20px;
    }
  }
  ul {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    margin-top: 40px;
    li {
      display: flex;
      align-items: center;
      .ic_tick {
        margin-right: 16px;
        @media ${device.mobileS} {
          transform: scale(0.7);
          margin-left: -3px;
          margin-right: 8px;
        }
      }
      p {
        font-size: 18px;
        line-height: 24px;
        span {
          font-weight: 900;
        }
        @media ${device.mobileS} {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
    @media ${device.mobileS} {
      gap: 14px;
      margin-top: 30px;
    }
  }
  .strikeText {
    font-weight: 400;
  }
`;
export const HeroPlusContRht = styled.div`
  flex-shrink: 0;
  text-align: center;
  h3 {
    display: none;
  }
  h4 {
    font-size: 24px;
    line-height: 32px;
    color: #4e3f6e;
    font-weight: 900;
  }
  p {
    font-size: 16px;
    line-height: 20px;
    span {
      font-weight: 700;
    }
    @media ${device.mobileS} {
      font-size: 14px;
      line-height: 20px;
    }
  }
  img {
    width: 470px;
    margin-bottom: 16px;
    @media ${device.mobileS} {
      width: 300px;
      margin-bottom: 20px;
    }
  }
  @media ${device.mobileS} {
    h3 {
      display: block;
      margin-bottom: 30px;
    }
  }
`;
